import axios from "axios";
import AppConfig from "config";

const TranscriptController = {
  async listTranscripts(page,date_start,date_end) {
    const jwtToken = localStorage.getItem('access_token');
    try {
      const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO+`audio_page/transcripts_for_page_audio`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
        params: {
          page: page,
          date_start: date_start,
          date_end: date_end
        }
      });
      return response.data.result;
    } catch (error) {
      console.error("Error fetching profiles:", error);
      throw error;
    }
  },
};

export default TranscriptController;